module.exports = __webpack_public_path__ + "939e83698b6eaa99cc4fef0c52031c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-icon001.png
// module id = 835
// module chunks = 3